import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { identityRequest, IdentityCapabilities } from "../../services/physicalIdentityApi";

export default function PhysicalIdentityNavLink({ compact = false, role }: { compact?: boolean; role?: string }) {
  const [enabled, setEnabled] = useState(false); const location = useLocation();
  useEffect(() => { let live = true; setEnabled(false); if (["SUPER_ADMIN", "ORGANIZATION_ADMIN", "ORGANIZATION_MANAGER"].includes((role || "").toUpperCase())) identityRequest<IdentityCapabilities>("/capabilities").then(c => { if (live) setEnabled(c.enabled); }).catch(() => undefined); return () => { live = false; }; }, [role]);
  return enabled ? <Link to="/physical-identities" data-tip="Physical Identity" aria-label="Physical Identity">
    <div className={location.pathname.startsWith("/physical-identities") ? "verticleNameP verticleNamePOnclick" : "verticleNameP"}>
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M3 3h6v6H3zM15 3h6v6h-6zM3 15h6v6H3zM15 15h3v3h3v3h-6z" /></svg>
      {!compact && <span className="verticleName">Physical Identity</span>}
    </div>
  </Link> : null;
}
